import $ from 'jquery';
import { ZoomLevel } from './marker'

export class ExtendedBoundsRenderer {

  private map: google.maps.Map;
  private scale: number;
  private markers: Array<google.maps.marker.AdvancedMarkerElement>
  private isEnabled: boolean;
  private extendedBounds: google.maps.LatLngBounds;
  private previousZoom: number;

  public constructor(map: google.maps.Map, scale: number, markers: Array<google.maps.marker.AdvancedMarkerElement>) {
    this.map = map;
    this.scale = scale;
    this.markers = markers;
    this.isEnabled = false;
    this.previousZoom = 20;

    google.maps.event.addListener(this.map, 'bounds_changed', this.onBoundsChanged.bind(this));
  }

  public enable(): void {
    this.isEnabled = true;
    this.redrawMarkers();
  }

  public disable(): void {
    this.isEnabled = false;
    this.extendedBounds = null;
    this.previousZoom = 20;
    this.markers.forEach(x => x.map = null);
  }

  public update(markers: Array<google.maps.marker.AdvancedMarkerElement>): void {
    this.markers.forEach(x => x.map = null);
    this.markers = markers;
    this.redrawMarkers();
  }

  private onBoundsChanged(): void {
    if (!this.isEnabled)
      return;

    let bounds = this.map.getBounds();
    let zoom = this.map.getZoom();

    let mapWasZoomedOutOrZoomNotChanged = zoom <= this.previousZoom;
    let extendedBoundsContainsTheCurrentBounds = ExtendedBoundsRenderer.extendedBoundsContainBounds(this.extendedBounds, bounds);

    if (mapWasZoomedOutOrZoomNotChanged && extendedBoundsContainsTheCurrentBounds) {
      this.previousZoom = zoom;
      return;
    }
    this.previousZoom = zoom;
    this.redrawMarkers();
  }

  private redrawMarkers(): void {
    if (!this.isEnabled || !this.map.getBounds())
      return;

    let zoom = this.map.getZoom();
    if (zoom > ZoomLevel.State) {
      this.extendedBounds = ExtendedBoundsRenderer.extendBounds(this.map.getBounds(), this.scale);
      this.markers.forEach(x => x.map = this.extendedBounds.contains(x.position) ? this.map : null);
    }
    else {
      this.extendedBounds = null;
      this.markers.forEach(x => x.map = null);
    }
  }

  public static extendedBoundsContainBounds(extendedBounds: google.maps.LatLngBounds, bounds: google.maps.LatLngBounds) {
    let north = bounds.getNorthEast().lat();
    let east = bounds.getNorthEast().lng();
    let south = bounds.getSouthWest().lat();
    let west = bounds.getSouthWest().lng();
    let northEast = new google.maps.LatLng(north, east);
    let northWest = new google.maps.LatLng(north, west);
    let southEast = new google.maps.LatLng(south, east);
    let southWest = new google.maps.LatLng(south, west);

    return extendedBounds && extendedBounds.contains(northWest) && extendedBounds.contains(northEast) && extendedBounds.contains(southEast) && extendedBounds.contains(southWest)
  }

  public static extendBounds(bounds: google.maps.LatLngBounds, scale: number): google.maps.LatLngBounds {
    let headingNorth = google.maps.geometry.spherical.computeHeading(bounds.getSouthWest(), bounds.getNorthEast());
    let headingSouth = google.maps.geometry.spherical.computeHeading(bounds.getNorthEast(), bounds.getSouthWest());

    let existingDistance = google.maps.geometry.spherical.computeDistanceBetween(bounds.getNorthEast(), bounds.getSouthWest());
    let scaledDistance = existingDistance * scale;
    let distanceNeededPerCoordinates = (scaledDistance - existingDistance) / 2;

    let largeNorthEast = google.maps.geometry.spherical.computeOffset(bounds.getNorthEast(), distanceNeededPerCoordinates, headingNorth);
    let largeSouthWest = google.maps.geometry.spherical.computeOffset(bounds.getSouthWest(), distanceNeededPerCoordinates, headingSouth);
    return new google.maps.LatLngBounds(largeSouthWest, largeNorthEast);
  }
}
